import React from 'react';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TButtonIcons } from './types/TButtons';

/**
 * ButtonIcon is predominantly used as a child of Button
 * @param name
 * @param color
 * @param isStartIcon
 * @param isEndIcon
 * @param rest
 * @returns {*}
 * @constructor
 */
const ButtonIcon = ({ name, isEndIcon = false, isStartIcon = !isEndIcon, ...rest }: TButtonIcons) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [isStartIcon && 'start', isEndIcon && 'end'],
  });
  return (
    <Box {...rest} {...conditionalProps} parent="Button" name="Icon" as="span">
      <Icon name={name} />
    </Box>
  );
};

export default React.memo(ButtonIcon);
